import useBundleTranslation from 'i18n';
import usePageForm from 'components/common/form/hooks/usePageForm';
import { FormRendererProps } from 'components/common/form';
import React, { useEffect, useRef } from 'react';
import { ActAfterSaveSuccess } from 'components/common/form/act';
import { Box, Button, Stack } from '@mui/material';
import { TemplateFormComponent } from 'components/common/form/layout/ReactHookFormController';
import FormConfirmation from 'components/common/form/confirmation/FormConfirmation';
import { ConfirmationComponentsMap } from 'components/common/form/confirmation';

export default function DevFormConfirmation() {
    const { t } = useBundleTranslation();
    const form = usePageForm({}, t, {
        settingsUrl: '/data/dev/form/confirmation',
    } as FormRendererProps);

    useEffect(() => {
        form.form.formAct.overrideAct(
            'afterSaveSuccess',
            class extends ActAfterSaveSuccess {
                public async exec(response: any, data: any): Promise<any> {
                    return new Promise(() => {
                        alert('Form submitted successfully!');
                        return super.exec(response, data);
                    });
                }
            },
        );
    }, [form]);

    const runExample = (index: number) => {
        form.form.hookFormSetValue('example', index, { shouldDirty: true });
        setTimeout(() => {
            if (submitRef.current) {
                submitRef.current.click();
            }
        });
    };
    const submitRef = useRef<HTMLButtonElement>(null);

    return (
        <Stack spacing={1}>
            <Box>Form Confirmation Example</Box>
            <Box>
                <form
                    autoComplete={'off'}
                    onSubmit={form.form.hookFormHandleSubmit(function (data) {
                        return form.form.formAct.act.submit.exec(data);
                    })}
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%',
                    }}
                >
                    <TemplateFormComponent component={'FormHidden'} elementProps={form} name={'example'} />
                    <Stack direction={'row'} spacing={2} sx={{ marginBottom: 2 }}>
                        <Button onClick={() => runExample(0)}>Simple Example</Button>
                        <Button onClick={() => runExample(1)}>2 Step Example</Button>
                        <Button onClick={() => runExample(2)}>Custom Component Example</Button>
                    </Stack>
                    <button style={{ display: 'none' }} ref={submitRef} type={'submit'}></button>
                </form>
                <FormConfirmation {...form.form.confirmation} />
            </Box>
            <Box>Allowed Custom Components:</Box>
            <Stack>{ConfirmationComponentsMap.keys().toArray().join(', ')}</Stack>
        </Stack>
    );
}
